;
define("product_views_option_color.tpl", function(){});

